/**
 * Параметр показывающий AB сегмент
 */
export const abSegment = window.app && window.app.abSegment
